import { render, staticRenderFns } from "./SettingsNavBar.vue?vue&type=template&id=4f5e38da&"
import script from "./SettingsNavBar.vue?vue&type=script&lang=js&"
export * from "./SettingsNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports